export const TOPICS = [
  { key: "gastronomia", es: "Gastronomía", en: "Gastronomy", it: "Gastronomia", icon: "UtensilsCrossed" },
  { key: "deportes", es: "Deportes", en: "Sports", it: "Sport", icon: "Dumbbell" },
  { key: "deportes_acuaticos", es: "Deportes acuáticos", en: "Water sports", it: "Sport acquatici", icon: "Waves" },
  { key: "musica_habaneras", es: "Música y Habaneras", en: "Music & Habaneras", it: "Musica e Habaneras", icon: "Music" },
  { key: "teatro_cultura", es: "Teatro y cultura", en: "Theatre & culture", it: "Teatro e cultura", icon: "Drama" },
  { key: "actividades_infantiles", es: "Actividades infantiles", en: "Kids activities", it: "Attività per bambini", icon: "Baby" },
  { key: "naturaleza", es: "Naturaleza", en: "Nature", it: "Natura", icon: "Trees" },
  { key: "fiestas_tradiciones", es: "Fiestas y tradiciones", en: "Festivals & traditions", it: "Feste e tradizioni", icon: "PartyPopper" },
  { key: "otro", es: "Otro", en: "Other", it: "Altro", icon: "Sparkles" },
];

export const topicLabel = (key, lang) => {
  const t = TOPICS.find((x) => x.key === key);
  return t ? t[lang] || t.es : key;
};

export const SLOT_TIMES = {
  s0900: "09:00 - 10:30",
  s0930: "09:30 - 11:00",
  s1730: "17:30 - 19:00",
  morning: "09:30 - 11:00",
  afternoon: "11:15 - 12:45",
  evening: "19:30 - 21:00",
};

export const slotTime = (slot) => SLOT_TIMES[slot] || slot;

export const italian = {
  flag: "🇮🇹",
  title: "Ciao! Parliamo italiano",
  text: "La nostra guida parla anche italiano. Contattaci per organizzare una prenotazione specifica per il tour a Torrevieja.",
  contact: "Contattaci",
  back: "Indietro",
  reviewPrompt: "Lasciaci la tua opinione",
  reviewPlaceholder: "Scrivi qui il tuo messaggio…",
  reviewSend: "Invia",
  reviewThanks: "Grazie per il tuo messaggio!",
  namePlaceholder: "Il tuo nome (facoltativo)",
};

export const t = {
  es: {
    brand: "Free Tour Torrevieja",
    langTitle: "Elige tu idioma",
    langSubtitle: "Choose your language",
    spanish: "Español",
    english: "Inglés",
    introTitle: "Bienvenido al Free Tour Torrevieja",
    introText:
      "Reserva tu plaza para descubrir Torrevieja de la mano de un guía local. La actividad es gratuita y funciona mediante aportaciones voluntarias al finalizar el recorrido.",
    introHelp:
      "La información proporcionada nos ayudará a personalizar la visita según tus intereses.",
    hoursInfo: "El tour es siempre de 9:30 a 11:00.",
    start: "Comenzar reserva",
    changeLang: "Cambiar idioma",
    back: "Atrás",
    next: "Continuar",
    stepDetails: "Tus datos",
    whatTitle: "¿Qué hacemos en Free Tour Torrevieja?",
    whatText:
      "En Free Tour Torrevieja enseñamos nuestra ciudad de una manera muy dinámica y divertida. Nuestro guía local, Héctor Fores, hará un recorrido guiado por el centro de Torrevieja en el que acabaréis conociendo nuestra historia, fiestas, tradiciones, gastronomía, oferta cultural y ecosistema como si hubieseis vivido en Torrevieja durante toda tu vida. Te esperamos",
    reviewsTitle: "Lo que dicen nuestros viajeros",
    reviewsSource: "Tripadvisor",
    continueToDetails: "Continuar con mis datos",
    stepDate: "Fecha del tour",
    name: "Nombre",
    email: "Email",
    phone: "Teléfono",
    firstVisit: "¿Es tu primera visita a Torrevieja?",
    yes: "Sí",
    no: "No",
    people: "¿Cuántas personas sois?",
    peopleHint: "Máximo 15 plazas por turno.",
    interests: "¿Qué temas te interesan?",
    customQuestion:
      "¿Hay algún tema concreto sobre Torrevieja que te gustaría conocer durante la visita?",
    customPlaceholder: "Escribe aquí (opcional)",
    rgpd:
      "Consiento el tratamiento de mis datos personales conforme al RGPD para gestionar mi reserva del Free Tour.",
    selectDate: "Selecciona la fecha de tu tour",
    dateHint: "Solo se muestran las fechas disponibles para tu idioma.",
    schedule: "Horario",
    morning: "Turno de mañana",
    afternoon: "Turno adicional",
    evening: "Turno de tarde-noche",
    slotFull: "Completo",
    spotsLeft: (n) => `${n} plazas libres`,
    spotsLegend: "el número bajo cada día son las plazas libres",
    morningFullNote:
      "El turno de las 9:30 está completo. Puedes reservar en el turno adicional de 11:15 a 12:45.",
    confirmBooking: "Confirmar reserva",
    submitting: "Enviando...",
    required: "Este campo es obligatorio",
    rgpdRequired: "Debes aceptar el consentimiento RGPD",
    pickDateFirst: "Selecciona una fecha y un turno",
    confTitle: "¡Reserva confirmada!",
    confText:
      "Gracias por reservar tu plaza para el Free Tour de Torrevieja. Recibirás una confirmación por correo electrónico en las próximas horas.",
    meetingPoint: "Punto de encuentro",
    meetingValue: "Plaza de la Constitución, Torrevieja",
    duration: "Duración aproximada",
    durationValue: "90 minutos",
    dateLabel: "Fecha",
    timeLabel: "Horario",
    newBooking: "Nueva reserva",
    errorGeneric: "No se pudo completar la reserva. Inténtalo de nuevo.",
    emailInvalid: "El correo introducido no existe o no es válido. Revísalo para poder reservar.",
    contact: "Contáctanos",
    contactTitle: "Contáctanos",
    contactDesc: "¿Tienes dudas? Escríbenos o llámanos.",
    phone: "Teléfono",
    existingTitle: "Ya tienes una reserva con este email",
    existingDesc: "Puedes cancelarla si ya no vas a asistir.",
    cancelBooking: "Cancelar reserva",
    cancelling: "Cancelando...",
    cancelled: "Reserva cancelada correctamente.",
    pendingTitle: "¡Casi listo! Confirma tu correo",
    pendingText: (email) => `Hemos enviado un email a ${email}. Ábrelo y pulsa "Confirmar mi reserva" para completar tu plaza.`,
    pendingWarn: "Si no confirmas el correo, tu reserva NO quedará registrada.",
    pendingSpam: "¿No lo ves? Revisa la carpeta de spam.",
    confirmingTitle: "Confirmando tu reserva…",
    confirmError: "El enlace no es válido o ha caducado.",
    availWeekdays: "Cada horario se realiza en un solo idioma (el del primer reservante).",
    otherLangSlot: "Reservado en otro idioma",
    goHome: "Volver al inicio",
    reviewPrompt: "Danos tu opinión",
    reviewPlaceholder: "Escribe aquí tu mensaje o reseña…",
    reviewName: "Tu nombre (opcional)",
    reviewSend: "Enviar",
    reviewSending: "Enviando…",
    reviewThanks: "¡Gracias por tu mensaje!",
  },
  en: {
    brand: "Free Tour Torrevieja",
    langTitle: "Choose your language",
    langSubtitle: "Elige tu idioma",
    spanish: "Spanish",
    english: "English",
    introTitle: "Welcome to the Torrevieja Free Tour",
    introText:
      "Book your spot to discover Torrevieja with a local guide. The activity is free and works through voluntary contributions at the end of the tour.",
    introHelp:
      "The information you provide helps us tailor the visit to your interests.",
    hoursInfo: "The tour always runs from 9:30 to 11:00.",
    start: "Start booking",
    changeLang: "Change language",
    back: "Back",
    next: "Continue",
    stepDetails: "Your details",
    whatTitle: "What do we do at Free Tour Torrevieja?",
    whatText:
      "At Free Tour Torrevieja we show our city in a very dynamic and fun way. Our local guide, Héctor Fores, will lead a guided walk through the centre of Torrevieja where you'll get to know our history, festivals, traditions, gastronomy, cultural life and ecosystem as if you had lived in Torrevieja all your life. We look forward to seeing you!",
    reviewsTitle: "What our travellers say",
    reviewsSource: "Tripadvisor",
    continueToDetails: "Continue to my details",
    stepDate: "Tour date",
    name: "Name",
    email: "Email",
    phone: "Phone",
    firstVisit: "Is this your first visit to Torrevieja?",
    yes: "Yes",
    no: "No",
    people: "How many people are you?",
    peopleHint: "Maximum 15 spots per time slot.",
    interests: "Which topics interest you?",
    customQuestion:
      "Is there a specific topic about Torrevieja you would like to learn about during the visit?",
    customPlaceholder: "Write here (optional)",
    rgpd:
      "I consent to the processing of my personal data under GDPR to manage my Free Tour booking.",
    selectDate: "Select your tour date",
    dateHint: "Only dates available for your language are shown.",
    schedule: "Schedule",
    morning: "Morning slot",
    afternoon: "Additional slot",
    evening: "Evening slot",
    slotFull: "Full",
    spotsLeft: (n) => `${n} spots left`,
    spotsLegend: "the number under each day shows free spots",
    morningFullNote:
      "The 9:30 slot is full. You can book the additional slot from 11:15 to 12:45.",
    confirmBooking: "Confirm booking",
    submitting: "Submitting...",
    required: "This field is required",
    rgpdRequired: "You must accept the GDPR consent",
    pickDateFirst: "Select a date and a time slot",
    confTitle: "Booking confirmed!",
    confText:
      "Thank you for booking your spot for the Torrevieja Free Tour. You will receive a confirmation by email in the next few hours.",
    meetingPoint: "Meeting point",
    meetingValue: "Plaza de la Constitución, Torrevieja",
    duration: "Approximate duration",
    durationValue: "90 minutes",
    dateLabel: "Date",
    timeLabel: "Time",
    newBooking: "New booking",
    errorGeneric: "The booking could not be completed. Please try again.",
    emailInvalid: "The email you entered does not exist or is invalid. Please check it to book.",
    contact: "Contact us",
    contactTitle: "Contact us",
    contactDesc: "Any questions? Email or call us.",
    phone: "Phone",
    existingTitle: "You already have a booking with this email",
    existingDesc: "You can cancel it if you are no longer attending.",
    cancelBooking: "Cancel booking",
    cancelling: "Cancelling...",
    cancelled: "Booking cancelled successfully.",
    pendingTitle: "Almost done! Confirm your email",
    pendingText: (email) => `We've sent an email to ${email}. Open it and click "Confirm my booking" to complete your spot.`,
    pendingWarn: "If you don't confirm your email, your booking will NOT be registered.",
    pendingSpam: "Can't find it? Check your spam folder.",
    confirmingTitle: "Confirming your booking…",
    confirmError: "The link is invalid or has expired.",
    availWeekdays: "Each time slot runs in a single language (the first booker's).",
    otherLangSlot: "Booked in another language",
    goHome: "Back to home",
    reviewPrompt: "Give us your opinion",
    reviewPlaceholder: "Write your message or review here…",
    reviewName: "Your name (optional)",
    reviewSend: "Send",
    reviewSending: "Sending…",
    reviewThanks: "Thanks for your message!",
  },
  it: {
    brand: "Free Tour Torrevieja",
    langTitle: "Scegli la tua lingua",
    langSubtitle: "Elige tu idioma",
    spanish: "Spagnolo",
    english: "Inglese",
    introTitle: "Benvenuto al Free Tour Torrevieja",
    introText:
      "Prenota il tuo posto per scoprire Torrevieja con una guida locale. L'attività è gratuita e funziona tramite contributi volontari al termine del tour.",
    introHelp:
      "Le informazioni fornite ci aiutano a personalizzare la visita in base ai tuoi interessi.",
    hoursInfo: "",
    start: "Inizia la prenotazione",
    changeLang: "Cambia lingua",
    back: "Indietro",
    next: "Continua",
    stepDetails: "I tuoi dati",
    whatTitle: "Cosa facciamo al Free Tour Torrevieja?",
    whatText:
      "Al Free Tour Torrevieja mostriamo la nostra città in modo molto dinamico e divertente. La nostra guida locale, Héctor Fores, vi accompagnerà in un percorso guidato per il centro di Torrevieja in cui conoscerete la nostra storia, feste, tradizioni, gastronomia, offerta culturale ed ecosistema come se aveste vissuto a Torrevieja per tutta la vita. Vi aspettiamo!",
    reviewsTitle: "Cosa dicono i nostri viaggiatori",
    reviewsSource: "Tripadvisor",
    continueToDetails: "Continua con i miei dati",
    name: "Nome",
    email: "Email",
    phone: "Telefono",
    firstVisit: "È la tua prima visita a Torrevieja?",
    yes: "Sì",
    no: "No",
    people: "Quante persone siete?",
    peopleHint: "Massimo 15 posti per turno.",
    interests: "Quali temi ti interessano?",
    customQuestion:
      "C'è un tema specifico su Torrevieja che vorresti conoscere durante la visita?",
    customPlaceholder: "Scrivi qui (facoltativo)",
    rgpd:
      "Acconsento al trattamento dei miei dati personali secondo il GDPR per gestire la mia prenotazione del Free Tour.",
    selectDate: "Seleziona la data del tuo tour",
    dateHint: "Vengono mostrate solo le date disponibili.",
    schedule: "Orario",
    morning: "Turno mattina",
    afternoon: "Turno aggiuntivo",
    evening: "Turno sera",
    slotFull: "Completo",
    spotsLeft: (n) => `${n} posti liberi`,
    spotsLegend: "il numero sotto ogni giorno sono i posti liberi",
    morningFullNote: "",
    confirmBooking: "Conferma prenotazione",
    submitting: "Invio in corso…",
    required: "Questo campo è obbligatorio",
    rgpdRequired: "Devi accettare il consenso GDPR",
    pickDateFirst: "Seleziona una data e un turno",
    confTitle: "Prenotazione confermata!",
    confText:
      "Grazie per aver prenotato il tuo posto per il Free Tour di Torrevieja. Riceverai una conferma via email nelle prossime ore.",
    meetingPoint: "Punto d'incontro",
    meetingValue: "Plaza de la Constitución, Torrevieja",
    duration: "Durata approssimativa",
    durationValue: "90 minuti",
    dateLabel: "Data",
    timeLabel: "Orario",
    newBooking: "Nuova prenotazione",
    errorGeneric: "Impossibile completare la prenotazione. Riprova.",
    emailInvalid: "L'email inserita non esiste o non è valida. Controllala per prenotare.",
    contact: "Contattaci",
    contactTitle: "Contattaci",
    contactDesc: "Hai domande? Scrivici o chiamaci.",
    existingTitle: "Hai già una prenotazione con questa email",
    existingDesc: "Puoi annullarla se non parteciperai più.",
    cancelBooking: "Annulla prenotazione",
    cancelling: "Annullamento…",
    cancelled: "Prenotazione annullata correttamente.",
    pendingTitle: "Ci siamo quasi! Conferma la tua email",
    pendingText: (email) => `Abbiamo inviato un'email a ${email}. Aprila e clicca "Conferma la mia prenotazione" per completare il tuo posto.`,
    pendingWarn: "Se non confermi l'email, la tua prenotazione NON sarà registrata.",
    pendingSpam: "Non la trovi? Controlla la cartella spam.",
    confirmingTitle: "Conferma della prenotazione in corso…",
    confirmError: "Il link non è valido o è scaduto.",
    availWeekdays: "Ogni turno si svolge in una sola lingua (quella del primo prenotante).",
    otherLangSlot: "Prenotato in un'altra lingua",
    goHome: "Torna all'inizio",
    reviewPrompt: "Lasciaci la tua opinione",
    reviewPlaceholder: "Scrivi qui il tuo messaggio o recensione…",
    reviewName: "Il tuo nome (facoltativo)",
    reviewSend: "Invia",
    reviewSending: "Invio…",
    reviewThanks: "Grazie per il tuo messaggio!",
  },
};
